<template>
    <div class="body">
      <div class="header">
        <el-form :model="ImpositionFileDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="文件名称">
            <el-input
              size="small"
              v-model="ImpositionFileDTO.fileName"
              placeholder="文件名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用功能名称">
            <el-input
              size="small"
              v-model="ImpositionFileDTO.productType"
              placeholder="使用功能名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="serchInfo">
              搜索
            </el-button>
            <el-button @click="submit" size="small" type="primary">下载</el-button>
            <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
          <el-form-item label="纸张宽度:单位/mm">
            <el-input
              size="small"
              v-model="param"
              placeholder="纸张宽度"
            ></el-input>
          </el-form-item>
        <el-form-item>
          <el-button @click="test" size="small" type="primary" :disabled="isLock">合并拼版</el-button>
        </el-form-item>
        </el-form>
        <div style="display: flex">


          <!-- <el-button size="small" type="primary">导入</el-button> -->
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <div class="pagination">

<el-pagination
  :current-page="currentPage"
  :page-sizes="[10, 30, 50, 100]"
  :page-size="pageSize"
  layout="total, sizes, prev, pager, next, jumper"
  :total="total"
  @size-change="handleSizeChange"
  @current-change="handleCurrentChange"
></el-pagination>
</div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
          <el-table-column
            prop="fileName"
            align="center"
            label="文件名称"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="上传时间"

          ></el-table-column>
          <el-table-column
    prop="thumbnail"
    label="缩略图"
    align="center"
    width="200" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click">
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnail"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnail" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnail" style="max-height: 50px;max-width: 50px cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
          <el-table-column
            prop="sizeWidth"
            align="center"
            label="宽度"

          ></el-table-column>

          <el-table-column
            prop="sizeHeight"
            align="center"
            label="高度"
          ></el-table-column>
          <el-table-column
          prop="number"
          align="center"
          label="数量"
        ></el-table-column>
          <el-table-column
            prop="productType"
            align="center"
            label="使用功能名称"
          ></el-table-column>

        </el-table>
      </div>

     

    </div>
  </template>

  <script>
  import { openLogin,bathDeleteFile,noticeImposition,downLoadComplete} from '@/api/unpacked'
  export default {
    data() {
      return {
        isLock: false,
        pageSize: 10,
        param:'1800',
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        cellClassName: {
          shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              picker.$emit('pick', [start, end])
            }
          },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
        date: '',
        conTract: [],
        ImpositionFileDTO:{
          fileName:'',
          productType:'',
            startTime: '',
            endTime: '',
            access: '',
            status: '1'
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        }
      }
    },
    mounted() {
      this.ImpositionFileDTO.access=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      getTableData() {
        openLogin(this.currentPage, this.pageSize, this.ImpositionFileDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      // 导入
      loadFile(file, fileList) {
        console.log(file, fileList)
        const formdata = new FormData()
        fileList.map((item) => {
          // fileList本来就是数组，就不用转为真数组了
          formdata.append('file', item.raw) // 将每一个文件图片都加进formdata
        })
        leadingIn(formdata).then((res) => {
          // console.log(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '导入成功!'
            })
            this.getTableData()
          }
        })
      },
      test(){
        this.isLock = true
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
          let name= this.multipleSelection[0].fileName;
        this.$message({
                type: 'success',
                message: '正在死命拼版中,请稍等!!!!',
              }),
        noticeImposition(this.multipleSelection, this.param).then((res) => {
          this.getTableData()
          if (res.data.msg === '操作成功') {
            fetch(`api/serviceCenter/imposition/downLoadComplete?access=${this.ImpositionFileDTO.access}`, {
      //body: JSON.stringify(this.ImpositionFileDTO.access),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        a.href = blobUrl;

      a.download =name+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        this.getTableData();
        this.isLock = false
      });
    });
    }
        })

      },
      getCurrentTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'年'+mm+'月'+dd+'日'+hh+'点'+mf+'分'+ss+'秒';
    console.log(_this.gettime)
    return _this.gettime;
    },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeleteFile(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {

            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },

      handleSelectionChange(val) {
        this.DeleteDTO=val
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.ImpositionFileDTO.startTime = e[0]
          this.ImpositionFileDTO.endTime = e[1]
        } else if (!e) {
          this.ImpositionFileDTO.startTime = ''
          this.ImpositionFileDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },

      submit() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
          let name= this.multipleSelection[0].fileName;
          this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
              }),
      fetch("api/serviceCenter/imposition/downLoadImpositionFile", {
      body: JSON.stringify(this.multipleSelection),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        a.href = blobUrl;

      a.download =name+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    });
    }
  }
}
  </script>

  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
    padding-bottom: 50px;
  }

  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  </style>
